exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar.no-tabs+.content.module[data-v-632f3582]:not(.legacy-container){margin-top:4.5rem}#layout.embedded[data-v-632f3582] .content.module{margin-top:0!important}.wrapper.centered[data-v-632f3582]{width:100%}.main-panel[data-v-632f3582]{overflow:visible;position:relative;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-632f3582","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Layouts/other.vue
// module id = DvhL
// module chunks = 12